import {on} from '@acng/frontend-bounty/dom/event.js';
import {LocalActor} from '@acng/frontend-relativity';
import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';

import {ctxListPosition} from '../context/list-position.js';
import {LIST_POSITION} from '@acng/frontend-discovery';
import {debug} from '@acng/frontend-bounty/dom/debug.js';

/**
 * Publish the {@link LIST_POSITION} event to the DOM subtree.
 *
 * @group DOM Attribute
 */
export const LIST_CONTROL = 'list-position';

AttributeSetup(LIST_CONTROL, (name) => {
  const broadcast = LocalActor(ctxListPosition);

  AttributeLink(name, (element) => {
    broadcast(element, null);
    on(element, LIST_POSITION, (evt) => {
      DEBUG: if (debug(element)) console.log(`[${name}]`, {evt});

      broadcast(element, evt);
    });
  });
});
